import React from 'react';
import './style.scss';
import { Card, Label, Popup } from 'semantic-ui-react';
import Render from 'components/Render';
import constants from 'app/constants/global-constants';
import useCaseIcons from '../../components/Icons/use-cases/index';
import Check from '../../components/Icons/CheckIcon';
import styleConstants from '../../assets/styles/style-constants';
var styles = {
    label: {
        fontWeight: 'normal',
        backgroundColor: styleConstants.colors.primary['10'],
        color: styleConstants.colors.primary['50'],
        fontSize: 14,
    },
    labelSuccess: {
        fontWeight: 'normal',
        backgroundColor: styleConstants.colors.success['10'],
        color: styleConstants.colors.success['50'],
        fontSize: 14,
    },
    labelPink: {
        fontWeight: 'normal',
        backgroundColor: styleConstants.colors.secondary['10'],
        color: styleConstants.colors.secondary['50'],
        fontSize: 14,
    },
    labelGreen: {
        fontWeight: 'normal',
        fontSize: 14,
    },
    iconContainer: {
        paddingBottom: 32,
    },
    popupContent: {
        color: styleConstants.colors.neutral['60'],
        fontSize: 14,
    }
};
var GDSLabelContent = React.createElement("span", { style: styles.popupContent },
    "Adds Graph Data Science related procedure capabilities to your database. You can learn more about it in the ",
    React.createElement("a", { target: "_blank", href: "https://neo4j.com/docs/graph-data-science/current/", rel: "noreferrer" }, "docs"));
var GraphQLLabelContent = React.createElement("span", null,
    "Enables GraphQL endpoints for your database. You can learn more about it in the ",
    React.createElement("a", { target: "_blank", href: "https://neo4j.com/docs/graphql-manual/current/", rel: "noreferrer" }, "docs"));
var PopupContent = {
    'GraphQL': GraphQLLabelContent,
    'Graph Data Science': GDSLabelContent
};
var SandboxItemComponent = function (props) {
    var item = props.item, isActive = props.isActive;
    var handleClick = function () {
        var onSandboxItemSelect = props.onSandboxItemSelect;
        onSandboxItemSelect(item);
    };
    return (React.createElement(Card, { as: "div", onClick: handleClick, style: {
            border: isActive ? "4px solid ".concat(styleConstants.colors.primary.DEFAULT) : "4px solid transparent",
        }, className: "uc-item ".concat(isActive ? 'active' : '') },
        React.createElement(Card.Content, { style: { padding: '16px 32px' } },
            React.createElement("div", { className: "sandbox-item-meta" },
                React.createElement("div", null,
                    React.createElement(Render, { if: constants.beginnerUsecases.indexOf(item.name) > -1 },
                        React.createElement(Label, { color: "green", horizontal: true, style: styles.labelGreen }, "Beginner")),
                    React.createElement(Render, { if: item.persona === 'data-scientist' },
                        React.createElement(Label, { color: "pink", horizontal: true, style: styles.labelPink }, "For Data Scientists")),
                    React.createElement(Render, { if: item.persona === 'developer' },
                        React.createElement(Label, { color: "blue", horizontal: true, style: styles.label }, "For Developers")),
                    React.createElement(Render, { if: item.name === "icij-offshoreleaks" },
                        React.createElement(Label, { color: "grey", horizontal: true, style: styles.labelSuccess }, "New"))),
                React.createElement(Render, { if: isActive },
                    React.createElement(Check, { color: styleConstants.colors.primary.DEFAULT, size: 24, viewBox: "0 0 10 10" })),
                React.createElement(Render, { if: !isActive },
                    React.createElement("span", { className: "check-circle" }))),
            React.createElement("div", { style: styles.iconContainer },
                React.createElement(Render, { if: item.logo }, item.logo({
                    size: 36,
                    color: styleConstants.colors.neutral['60'],
                })),
                React.createElement(Render, { if: !item.logo },
                    React.createElement(useCaseIcons.BlankSandbox, { size: 36, color: styleConstants.colors.neutral['60'] }))),
            React.createElement(Card.Header, { style: { marginBottom: 12 } },
                React.createElement("div", null, item.long_name)),
            React.createElement(Card.Description, null,
                React.createElement("div", null, item.description)),
            React.createElement(Render, { if: item.graphLibrariesEnabled },
                React.createElement(Card.Description, null,
                    React.createElement("div", { className: "mt3" },
                        React.createElement("span", { className: "mr2" }, "Libraries Enabled: "),
                        item.graphLibrariesEnabled && item.graphLibrariesEnabled.map(function (library) {
                            return React.createElement(Popup, { hoverable: true, position: "bottom center", content: PopupContent[library], trigger: React.createElement(Label, { className: "font-regular", basic: true }, library) });
                        })))))));
};
export default SandboxItemComponent;
